<template>
  <div>
    <v-dialog
        v-model="dialog"
        width="80%"
        hide-overlay
        outline
    >
        <template v-slot:activator="{ on }">
            <v-btn
                data-testid="facility-edit-review-btn"
                class="facility-edit-review-btn"
                v-on="on"
                color="primary"
                small
            >
              Edit
            </v-btn>
        </template>

      <v-form
        @submit.prevent="submitEditReviewForm"
        ref="editReviewForm"
      >
        <v-card>
          <v-card-title class="headline" primary-title>
            Edit Review
          </v-card-title>
          <v-divider />
          <v-container>
            <v-row>
              <v-col class="pr-3" sm="6">
                <app-input
                    data-testid="facility-edit-review-first-name-input"
                    class="facility-edit-review-first-name-input"
                    :type="'text'"
                    v-model="review.first_name"
                    label="First Name"
                    :rules="{ required: true }"
                    :useValidation="true"
                />
              </v-col>
              <v-col class="pl-3" sm="6">
                <app-input
                    data-testid="facility-edit-review-last-name-input"
                    class="facility-edit-review-last-name-input"
                    :type="'text'"
                    v-model="review.last_name"
                    label="Last Name"
                    :rules="{ required: true }"
                    :useValidation="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pr-3" sm="6">
                <app-input
                    data-testid="facility-edit-review-email-input"
                    class="facility-edit-review-email-input"
                    :type="'email'"
                    v-model="review.email"
                    label="E-mail"
                    :rules="{ required: true, email: true }"
                    :useValidation="true"
                />
              </v-col>
              <v-col class="pl-3" sm="6">
                <app-input
                    data-testid="facility-edit-review-rating-input"
                    class="facility-edit-review-rating-input"
                    :type="'text'"
                    v-model="review.rating"
                    label="Rating"
                    disabled
                />
              </v-col>
            </v-row>
            <v-col class="mt-2">
                <v-textarea
                    data-testid="facility-edit-review-content-textarea"
                    class="facility-edit-review-content-textarea"
                    filled
                    v-model="review.content"
                    label="Review"
                    rows="5"
                    required
                    clearable
                />
            </v-col>
          </v-container>
          <v-divider />
          <v-card-actions>
            <v-btn
                data-testid="facility-edit-review-cancel-btn"
                class="facility-edit-review-cancel-btn"
                color="error"
                @click="dialog = false"
            >
                Cancel
            </v-btn>
            <v-spacer />
            <v-btn
                data-testid="facility-edit-review-save-btn"
                class="facility-edit-review-save-btn"
                color="primary"
                type="submit"
                :loading="loading"
            >
                Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>

    </v-dialog>
  </div>
</template>

<script>
import AppInput from "@/components/global/AppInput";
export default {
  props: {
    review: {
      type: Object
    }
  },

  data() {
    return {
      dialog: false,
      loading: false
    };
  },

  computed: {
    currentFacility: {
      get() {
        return this.$store.state.facility.currentFacility;
      },

      set(newValue) {
        this.$store.commit("setCurrentFacilityData", newValue);
      }
    }
  },

  methods: {
    submitEditReviewForm() {
      this.loading = true;

      this.$store.dispatch("updateReview", this.review)
        .then(() => {
          this.dialog = false;
        });

      this.loading = false;
    }
  },

  components: {
    AppInput
  }
};
</script>
